import script from "./BtnRemover.vue?vue&type=script&setup=true&lang=js"
export * from "./BtnRemover.vue?vue&type=script&setup=true&lang=js"

import "./BtnRemover.vue?vue&type=style&index=0&id=2939c760&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2939c760"]])

export default __exports__